/* eslint-disable no-unused-vars */
export interface CreateAppMagazineProps {
  app_name: string,
  latin_name: string,
  os_type: number[]
  app_id?: string
  shared_secret?: string
  public_secret?: string
  ios_app_id?: string
  android_app_id?: string
}

export enum OS_TYPE {
  IOS = 1,
  ANDROID = 2,
  WEB = 3,
}

export enum SaleType {
  NOT_SOLE_YET = 1,
  ONCE = 2,
  FREE = 3
}

export enum IsSubscribeType {
  NOT_SUBSCRIBE = 0,
  SUBSCRIBE = 1
}

export enum DirectionType {
  RTL = 1, //right to left
  LTR = 2 //left to right
}

export enum PageViewType {
  DOUBLE_PAGE = 1,
  SINGLE_PAGE = 2
}

export interface RequestMagazineType {
  name: string
  publish_at?: string
  sale_type: SaleType
  magazine_app_id: number
  description?: string
  file_upload: File
  reading_direction: DirectionType
  page_view_type: PageViewType
  read_trial_page?: string
  table_of_contents?: string
  single_pages?:string
}

export interface ResponseMagazineType {
  id: number
  magazine_app_id: number
  name: string
  description: string
  category_id: number
  reading_direction_type: number
  sale_type: number
  page_view_type: PageViewType,
  single_pages: string,
  read_trial_page: string
  main_file_url: string
  file_size: number
  file_name: string
  product_id: string
  android_product_id?:string
  thumbnail_url: string
  table_of_contents?: any[]
  publish_at: number | string
  distribution_start_at: string
  distribution_end_at: string
  created_at: number
  updated_at: number
  total_page: number
  is_subscribable: IsSubscribeType
}

export interface reqUpdateMuntipleMagazineType {
  magazine_id: number
  sale_type?: number
  category_id?: number
  distribution_start_at?: string
  distribution_end_at?: string
  product_id?: string,
  android_product_id?:string
}
